import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { BUSINESS } from "../../data/content";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3" data-testid="whatsapp-widget">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.96 }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="w-72 rounded-2xl bg-white shadow-2xl border border-black/5 overflow-hidden"
          >
            <div className="bg-[#25D366] text-white p-4 flex items-center gap-3">
              <span className="grid place-items-center w-10 h-10 rounded-full bg-white/20">
                <MessageCircle className="w-5 h-5" />
              </span>
              <div className="leading-tight">
                <p className="font-heading font-bold">Mark Clean Services</p>
                <p className="text-xs text-white/80">Typically replies within minutes</p>
              </div>
            </div>
            <div className="p-4">
              <div className="rounded-xl bg-mist p-3 text-sm text-navy">
                Hi there! 👋 How can we help with your cleaning or valeting today?
              </div>
              <a
                href={`${BUSINESS.whatsapp}?text=${encodeURIComponent("Hi Mark Clean Services, I'd like to enquire about your services.")}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-start-chat"
                className="mt-3 flex items-center justify-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1da851] text-white py-3 font-semibold transition-colors"
              >
                <MessageCircle className="w-4 h-4" /> Start Chat
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-toggle"
        aria-label="Chat on WhatsApp"
        className="relative grid place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl hover:scale-105 active:scale-95 transition-transform"
      >
        {!open && (
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        )}
        {open ? <X className="w-6 h-6 relative" /> : <MessageCircle className="w-7 h-7 relative" />}
      </button>
    </div>
  );
}
